import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardFooter,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import { useMemo, React, useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { MainContext } from "context/MainContext.js";
import { FaCheckCircle } from "react-icons/fa";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const GroupList = () => {
  const history = useHistory();
  const [alert, setAlert] = useState(null);
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.groups.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const [forceRefreshCount, setForceRefreshCount] = useState(0);

  const redirectToGroupViewPage = (group) => {
    const location = {
      pathname: "/admin/groups/edit",
      state: {
        value: "group||" + group,
        mode: "view",
      },
    };
    history.push(location);
  };

  const redirectToGroupEditPage = (group) => {
    const location = {
      pathname: "/admin/groups/edit",
      state: {
        value: group ? "group||" + group : "",
        mode: group ? "edit" : "create",
      },
    };
    history.push(location);
  };

  const deleteGroupConfirm = (id, name) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure you want to delete this group ?"
        onConfirm={() => {
          deleteGroup(id);
        }}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="info"
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
        You will not be able to recover the group '{name}'
      </ReactBSAlert>,
    );
  };

  const deleteGroup = (id) => {
    const start = Date.now();

    // Call the API
    fetch("/api/v1/group/delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: id,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.error_code) {
          errorDelete(actualData.error_code[0]);
        } else {
          successDelete();
          setForceRefreshCount((prevValue) => ++prevValue);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const successDelete = () => {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Deleted!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        btnSize=""
      >
        The group has been deleted.
      </ReactBSAlert>,
    );
  };

  const errorDelete = (errorMessage) => {
    setAlert(
      <ReactBSAlert
        error
        style={{ display: "block", marginTop: "-100px" }}
        title="Error!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        btnSize=""
      >
        {errorMessage}
      </ReactBSAlert>,
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const redirectToDeviceList = (group) => {
    const location = {
      pathname: "/admin/devices/list",
      state: { value: "group||" + group },
    };
    history.push(location);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        sortBy: "name",
        flex: "1 1 0",
      },
      {
        Header: "Description",
        accessor: "description",
        sortBy: "description",
        flex: "1 1 0",
      },
      {
        Header: "Devices",
        accessor: "devicesCount",
        Cell: (props) => {
          return (
            <a
              onClick={() => redirectToDeviceList(props.row.original.id)}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {props.value}
            </a>
          );
        },
        sortable: false,
        flex: "1 1 0",
      },
      {
        Header: "Subgroups",
        accessor: "subgroups",
        sortable: false,
        flex: "1 1 0",
      },
      {
        Header: "System Group",
        accessor: "systemGroup",
        sortable: false,
        flex: "1 1 0",
        Cell: (props) => {
          return props.value ? (
            <FaCheckCircle className="text-primary tableIconFontSize" />
          ) : (
            ""
          );
        },
      },
      {
        Header: "",
        accessor: "actions",
        Cell: (props) => {
          return (
            <UncontrolledDropdown direction="down">
              <DropdownToggle
                caret
                color="info"
                style={{
                  padding: "6px 14px 6px 14px",
                  margin: "0px",
                }}
              >
                Actions
              </DropdownToggle>
              <DropdownMenu container={"body"}>
                <DropdownItem
                  onClick={() => redirectToGroupViewPage(props.row.original.id)}
                >
                  View Details
                </DropdownItem>
                {Utilities.hasAccess(privileges["devices.groups.edit"]) &&
                !props.row.original.systemGroup ? (
                  <DropdownItem
                    onClick={() =>
                      redirectToGroupEditPage(props.row.original.id)
                    }
                  >
                    Edit Group
                  </DropdownItem>
                ) : (
                  ""
                )}

                {Utilities.hasAccess(privileges["devices.groups.delete"]) &&
                !props.row.original.systemGroup ? (
                  <>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() =>
                        deleteGroupConfirm(
                          props.row.original.id,
                          props.row.original.name,
                        )
                      }
                    >
                      Delete Group
                    </DropdownItem>
                  </>
                ) : (
                  ""
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
        flex: "1 1 0",
        padding: "5px 0px 0px 0px",
        sortable: false,
        filterable: false,
      },
    ],
    [],
  );

  return (
    <div className="content">
      {alert}
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <Breadcrumb>
                <BreadcrumbItem>
                  <NavLink
                    to={{
                      pathname: "/admin/dashboard",
                    }}
                  >
                    <FontAwesomeIcon icon={faHome} />
                  </NavLink>
                </BreadcrumbItem>
                <BreadcrumbItem>Groups</BreadcrumbItem>
              </Breadcrumb>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <ReactTable
                query="/api/v1/group/list"
                columns={columns}
                title="Groups"
                className="-striped -highlight primary-pagination"
                forceRefresh={forceRefreshCount}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default GroupList;
